export default "__VITE_PUBLIC_ASSET__ff4ce3ba__"